
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/apollo",
      function () {
        return require("private-next-pages/destinations/apollo.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/apollo"])
      });
    }
  